import { DataGrid } from '@mui/x-data-grid';
import { Grid, LinearProgress } from '@mui/material';
import { CustomPagination } from 'utils/functions';
import Title from '../Components/Title';
import localeText from 'utils/localeText';

const Ponto = ({ loading, pessoal = {} }) => {
  const pontos = pessoal?.Pontos ?? [];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Title title="Pontos" disableMargin />
      </Grid>
      <Grid item xs={12}>
        <DataGrid
          rows={pontos}
          columns={[
            {
              field: 'data',
              headerName: 'Data',
              width: 200,
              sortable: false,
              valueGetter: ({ value }) =>
                value && moment(value).format('DD/MM/YYYY'),
            },
            {
              field: 'hora',
              headerName: 'Hora',
              width: 200,
              sortable: false,
              valueGetter: ({ value }) =>
                value && moment(value).format('HH:mm'),
            },
            {
              field: 'tpreg',
              headerName: 'Tipo de Registro',
              width: 300,
              sortable: false,
            },
            {
              field: 'justificativa',
              headerName: 'Justificativa',
              minWidth: 300,
              flex: 1,
              sortable: false,
            },
          ]}
          autoHeight
          pagination
          pageSize={10}
          density="compact"
          loading={loading}
          disableColumnMenu
          showCellRightBorder
          showColumnRightBorder
          disableSelectionOnClick
          localeText={localeText}
          getRowHeight={() => 'auto'}
          components={{
            Pagination: CustomPagination,
            LoadingOverlay: LinearProgress,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default Ponto;
